import { useAppSelector } from '../hooks';

export default function OfferSkeleton() {
    const selectedCode = useAppSelector(s => s.offers.selectedCode);

    if (selectedCode === null) {
        return (
            <div className="flex items-center justify-center h-full">
                <p className="text-base-content/60">Выберите предложение</p>
            </div>
        );
    }

    // Loading skeleton
    return (
        <div className="h-full flex flex-col animate-pulse p-6 gap-4">
            <div className="flex gap-3">
                <div className="h-8 bg-base-300 rounded w-48" />
                <div className="h-8 bg-base-300 rounded w-32" />
                <div className="h-8 bg-base-300 rounded w-24" />
                <div className="flex-1" />
                <div className="h-8 bg-base-300 rounded w-36" />
            </div>
            <div className="flex-1 flex flex-col gap-2">
                <div className="h-10 bg-base-300 rounded w-full" />
                {Array.from({ length: 8 }).map((_, i) => (
                    <div key={i} className="h-9 bg-base-200 rounded w-full" />
                ))}
            </div>
        </div>
    );
}
